"use client";

import EmbedConsent from "rivals/components/shared/EmbedConsent";
import { setData } from "rivals/shared/utils/qa";
import styles from "./InstagramBlock.module.scss";
import type { Props } from "./types";

const DATA_PHILTER = "instagram-block";

function InstagramBlock({ html, hasEmbedConsent }: Props): React.JSX.Element {
  if (!hasEmbedConsent) {
    return <EmbedConsent />;
  }

  return (
    <div
      className={styles.container}
      dangerouslySetInnerHTML={{
        // Remove hardcoded no scrolling from iframe
        // Add title to the iframe
        __html: html.replace('scrolling="no"', `title="instagram-embed"`)
      }}
      {...setData(DATA_PHILTER)}
    />
  );
}

export default InstagramBlock;
